import { Box, CircularProgress, Stack, Typography, circularProgressClasses } from '@mui/material';
import { abyssColors } from '@/theme/colors';

type ProgressProps = {
  progress: number;
};

export const ReportsProgress = ({ progress }: ProgressProps) => {
  return (
    <Stack direction="row" gap={1} alignItems="center">
      <Typography color={abyssColors.primary[400]} fontSize="1.2rem">
        {progress}%
      </Typography>
      <Box
        sx={{ position: 'relative', height: 'fit-content', display: 'flex', alignItems: 'center' }}
      >
        <CircularProgress
          variant="determinate"
          sx={{
            color: abyssColors.primary[100],
          }}
          size={24}
          thickness={3}
          value={100}
        />
        <CircularProgress
          value={progress}
          variant="determinate"
          size={24}
          thickness={5}
          disableShrink
          sx={{
            position: 'absolute',
            left: 0,
            '& .MuiCircularProgress-circleDeterminate': {
              color: abyssColors.success[500],
            },
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'square',
            },
          }}
        />
      </Box>
    </Stack>
  );
};
